import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { ANALYTIC_PRODUCT_SCORE_METRIC } from 'modules/reports/interfaces/IReportProductScore';

class AnalyticProductScoreService extends EntityApiService<any> {
  searchAnalytic = (
    metric: ANALYTIC_PRODUCT_SCORE_METRIC,
    params?: any,
    config?: RequestConfig,
  ) =>
    this.handleResponse(
      ApiClientService.post(this.getPath(`/${metric}`), params, config),
    );
}

export default new AnalyticProductScoreService(
  '/ms-analytics/api/v1/product-score-analytic',
);
